<template>
    <div :key="tableKey">
        <div v-if="loading">
            <loading></loading>
        </div>

        <div v-else>
            <b-alert variant="danger" :show="hasErrors">
                <span v-html="errorMessage"></span>
            </b-alert>
            <!-- filter -->
            <b-row v-if="!hasErrors" class="mb-3">
                <b-col md="6" class="my-1"> </b-col>
                <b-col md="6" class="my-1">
                    <b-form-group label-cols-sm="3" class="mb-0">
                        <b-input-group size="sm">
                            <b-form-input
                                v-model="filter"
                                placeholder="Entrer la valeur recherchée"
                            ></b-form-input>
                            <b-input-group-append>
                                <b-button
                                    :disabled="!filter"
                                    @click="filter = ''"
                                    >Effacer</b-button
                                >
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <!-- /filter -->

            <!-- Table -->
            <b-table
                responsive
                small
                :items="items"
                :fields="fields"
                :filter="filter"
                :per-page="perPage"
                :current-page="currentPage"
                primary-key="id"
                @filtered="onFiltered"
            >
                <template #cell(id)="data">
                    <delete-pending-point :point="data.item" />
                </template>
                <template #cell(uuid)="data">
                    <duplicate-pending-point :point="data.item" />
                </template>
                <template #cell(status)="data">
                    <send-pending-point :point="data.item" />
                </template>
                <template #cell(entry_date)="data">
                    <entry-date-form :point="data.item" />
                </template>
                <template #cell(document)="data">
                    <document-form :point="data.item" />
                </template>
                <template #cell(description)="data">
                    <description-form :point="data.item" />
                </template>
                <template #cell(debit)="data">
                    <span> {{ Number(data.item.debit).toFixed(2) }}</span>
                </template>
                <template #cell(credit)="data">
                    <span> {{ Number(data.item.credit).toFixed(2) }}</span>
                </template>
                <template #cell(question)="data">
                    <question-form :point="data.item" />
                </template>

                <template #row-details="row">
                    <chat :point="row.item" />
                    <b-button size="sm" class="m-1" @click="row.toggleDetails"
                        >Fermer la conversation</b-button
                    >
                </template>
            </b-table>
            <!-- /Table -->

            <!-- Pagination -->
            <b-row>
                <b-col md="3" class="my-1 text-center">
                    <b-pagination
                        v-if="totalRows > 0"
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        class="my-0"
                        size="sm"
                    ></b-pagination>
                </b-col>
                <b-col md="6" class="my-2">
                    <p class="text-center small pt-0">{{ legend }}</p>
                </b-col>
                <b-col md="3" class="my-1 text-right">
                    <b-dropdown
                        right
                        split
                        size="sm"
                        :text="perPage + ' éléments par page'"
                    >
                        <b-dropdown-item
                            v-for="pageOption in pageOptions"
                            :key="pageOption"
                            @click="setPerPage(pageOption)"
                        >
                            {{ pageOption }}
                        </b-dropdown-item>
                    </b-dropdown>
                </b-col>
            </b-row>
            <!-- /Pagination -->
        </div>
    </div>
</template>

<script>
import TableHandler from '../../../../common/mixins/TableHandler'
import Chat from './Chat'
import QuestionForm from './tableForms/QuestionForm'
import DocumentForm from './tableForms/DocumentForm'
import DescriptionForm from './tableForms/DescriptionForm'
import EntryDateForm from './tableForms/EntryDateForm'

export default {
    name: 'TableImported',

    components: {
        EntryDateForm,
        DescriptionForm,
        DocumentForm,
        Chat,
        QuestionForm,
    },

    mixins: [TableHandler],

    props: {
        client: Number,
    },

    data() {
        return {
            fields: [
                {
                    key: 'id',
                    label: '',
                    class: 'td-icon',
                },
                {
                    key: 'status',
                    label: '',
                    class: 'td-icon',
                },
                {
                    key: 'uuid',
                    label: '',
                    class: 'td-icon',
                },
                {
                    key: 'entry_date',
                    label: 'Date',
                    class: 'td-sm td-deadline',
                    sortable: true,
                },
                {
                    key: 'account_code',
                    label: 'N° Compte',
                    class: 'td-sm',
                    sortable: true,
                },
                {
                    key: 'account_name',
                    label: 'Compte',
                    class: 'td-sm',
                    sortable: true,
                },
                {
                    key: 'document',
                    label: 'Pièce',
                    class: 'td-sm',
                    sortable: true,
                },
                {
                    key: 'description',
                    label: 'Libellé',
                    class: 'td-sm',
                    sortable: true,
                },
                {
                    key: 'debit',
                    label: 'Débit',
                    class: 'td-sm text-right',
                    sortable: true,
                },
                {
                    key: 'credit',
                    label: 'Crédit',
                    class: 'td-sm text-right',
                    sortable: true,
                },
                {
                    key: 'question',
                    label: 'Question',
                    class: 'td-sm td-question',
                    sortable: true,
                },
            ],
        }
    },

    async created() {
        this.filterable = false
        // this.$store.commit('browsing/SET_PAGE_NAME', 'pendingImportedTable')
        await this.getItems()
    },

    methods: {
        async getItems() {
            try {
                this.loading = true
                const response = await axios.get(
                    `/clients/${this.client}/pendingPoints/imported`
                )
                this.items = response.data.data
                this.loading = false
            } catch (error) {
                // handle error
                console.log(error)
                this.handleErrors(error.response)
            }
        },

        updateCounters() {
            this.$store.dispatch('clientVM/getCounters', this.client)
        },
    },
}
</script>

<style scoped></style>
